function imageSupportsWebPParam(src) {
  return /pedidosya.dhmedia.io/.test(src);
}

export default imageSupportsWebPParam;
